import { Box, Stack, Typography } from '@rabex-kit/rabex-ui';
import Check from '../../static/images/svg/check.svg';
import RedClose from '../../static/images/svg/red-close.svg';
import { PASSWORD_RULES } from '@/utils/passwordRules';

/** A tick or a cross per rule in utils/passwordRules, the same rules the form validates with. */
const PasswordChecklist = ({ password }: { password: string }) => (
  <Stack gap={1.5}>
    {PASSWORD_RULES.map((rule) => (
      <Box
        key={rule.label}
        sx={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
        {rule.test(password) ? (
          <img
            src={Check}
            alt="رعایت شده"
            style={{ width: '12px', height: '12px' }}
          />
        ) : (
          <img src={RedClose} alt="رعایت نشده" />
        )}
        <Typography variant="body3">{rule.label}</Typography>
      </Box>
    ))}
  </Stack>
);

export default PasswordChecklist;
